import { render, staticRenderFns } from "./ProjectComments.vue?vue&type=template&id=790c9c74"
import script from "./ProjectComments.vue?vue&type=script&lang=js"
export * from "./ProjectComments.vue?vue&type=script&lang=js"
import style0 from "./ProjectComments.vue?vue&type=style&index=0&id=790c9c74&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports